"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var PlanItem_1 = __importDefault(require("./PlanItem"));
var HorizontalPlans_1 = __importDefault(require("./HorizontalPlans"));
// TODO: move to scss modules
require("./styles.scss");
var SubscriptionPlans = function (_a) {
    var plans = _a.plans, onSubscribe = _a.onSubscribe;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(HorizontalPlans_1.default, { subscriptionPlans: plans, className: "horizontal_plans", onSubscribe: onSubscribe }),
        react_1.default.createElement("div", { className: "home-plans container-1024" }, plans.map(function (plan) {
            return (react_1.default.createElement(PlanItem_1.default, { plan: plan, key: plan.id, onSubscibe: onSubscribe }));
        }))));
};
exports.default = SubscriptionPlans;
